import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@heroui/react';
import { Widget } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils';
import type { ProductDetail } from '@/api/models';
import { ProductDetailSectionHeading } from './ProductDetailSectionHeading';

type ProductDetailOptionsProps = {
    /** The product's variant axes, in its order; at least one. */
    options: ProductDetail['options'];
};

/** A variable product's options (its variant axes) as chips. */
export const ProductDetailOptions: React.FC<ProductDetailOptionsProps> = ({
    options,
}) => {
    const { t } = useTranslation('pages');

    return (
        <Widget
            className="flex flex-col gap-3 p-5"
            {...getNodeTestIdProp('product-detail-options')}
        >
            <ProductDetailSectionHeading>
                {t('products.detail.options.title')}
            </ProductDetailSectionHeading>
            <div className="flex flex-wrap gap-2">
                {options.map((option) => (
                    <Chip
                        color="default"
                        key={option.attributeTypeId}
                        size="sm"
                        variant="soft"
                        {...getNodeTestIdProp(
                            `product-detail-option-${option.attributeTypeId}`,
                        )}
                    >
                        <Chip.Label>{option.name}</Chip.Label>
                    </Chip>
                ))}
            </div>
        </Widget>
    );
};
